import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-result" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "footer-actions" }

import { computed, reactive, ref, unref } from "vue";
import { useI18n } from "vue-i18n";
import AdvancedSearch from "./AdvancedSearch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvancedSearchModal',
  props: {
    value: { type: Boolean },
    advancedSearchId: {},
    executeSearchOnStart: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;




const { t: $t } = useI18n();

const vm = reactive({
  resultCount: undefined
});

const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

const advancedSearch = ref<InstanceType<typeof AdvancedSearch> | null>(null);

const hideModal = () => {
  localModel.value = false;
};

const hideHandler = (event: any) => {
  const advSearchObj = unref(advancedSearch);
  if (advSearchObj?.states?.isDirty && !confirm($t("confirm.hasUnsavedData"))) event.preventDefault();
};

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _unref($t)('advancedSearch'),
    id: "advanced-search-modal",
    "dialog-class": "advanced-search-dialog",
    "header-close-content": "",
    size: "xl",
    "body-class": "advanced-search-modal",
    modelValue: localModel.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localModel).value = $event)),
    onHide: hideHandler
  }, {
    "modal-footer": _withCtx(({ cancel }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (vm.resultCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`${_unref($t)("searchResults")}: ${vm.resultCount}`), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_btn, {
            onClick: cancel,
            "data-cy": "advanced-search-close-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("Close")), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(AdvancedSearch, {
        ref_key: "advancedSearch",
        ref: advancedSearch,
        "advanced-search-id": props.advancedSearchId,
        "execute-search-on-start": props.executeSearchOnStart,
        onHide: hideModal,
        "result-count": vm.resultCount,
        "onUpdate:resultCount": _cache[0] || (_cache[0] = ($event: any) => ((vm.resultCount) = $event))
      }, null, 8, ["advanced-search-id", "execute-search-on-start", "result-count"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})